import React, { useEffect, useState } from "react";
import "./hydrafacial.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import heroImage from "../../../assets/images/ad-antiageinglaser.jpg";
import heroImage1 from "../../../assets/images/ad-antiageinglaser1.jpg";
import favicon from "../../../assets/images/favicon.ico";

import deepCleansingIcon from "../../../assets/images/deep-cleansing.png";
import enhancedHydrationIcon from "../../../assets/images/enhanced-hydration.png";
import skinRenewalIcon from "../../../assets/images/skin-renewal.png";
import nonInvasiveIcon from "../../../assets/images/non-invasive.png";

// Import PNG icons for navigation treatments
import hydrafacialIcon from "../../../assets/images/botox.png";
import acneIcon from "../../../assets/images/navacne.png";
import skinBrighteningIcon from "../../../assets/images/skin-brightening.png";
import antiAgeingIcon from "../../../assets/images/anti-ageing.png";
import youthIcon from "../../../assets/images/youth.png";
import prpFaceIcon from "../../../assets/images/prpface.png";
import co2FacialIcon from "../../../assets/images/co2.png";
import acneScarIcon from "../../../assets/images/acnescar.png";
import moleBirthMarkIcon from "../../../assets/images/wart.png";
import tattoRemovalIcon from "../../../assets/images/tattoo.png";
import wartsRemovalIcon from "../../../assets/images/blackhead.png";
import antiAgeingLaserIcon from "../../../assets/images/laser.png";
import laserHairRemovalIcon from "../../../assets/images/laserHairRemoval.png";

const treatments = [
  { name: "ADVANCED HYDRAFACIAL" },
  { name: "ACNE" },
  { name: "ANTI AGEING" },
  { name: "YOUTH" },
  { name: "PRP FACE" },
  { name: "CO2 FACIAL" },
  { name: "ACNE SCAR" },
  { name: "MOLE & BIRTH MARK REMOVAL" },
  { name: "SKIN BRIGHTENING" },
  { name: "TATTO REMOVAL" },
  { name: "WARTS REMOVAL" },
  { name: "ANTI AGEING LASER" },
  { name: "LASER HAIR REMOVAL" },
];

// Mapping treatment names to their PNG icons
const treatmentIconPNGMap = {
  "ADVANCED HYDRAFACIAL": hydrafacialIcon,
  "ACNE": acneIcon,
  "SKIN BRIGHTENING": skinBrighteningIcon,
  "ANTI AGEING": antiAgeingIcon,
  "YOUTH": youthIcon,
  "PRP FACE": prpFaceIcon,
  "CO2 FACIAL": co2FacialIcon,
  "ACNE SCAR": acneScarIcon,
  "MOLE & BIRTH MARK REMOVAL": moleBirthMarkIcon,
  "TATTO REMOVAL": tattoRemovalIcon,
  "WARTS REMOVAL": wartsRemovalIcon,
  "ANTI AGEING LASER": antiAgeingLaserIcon,
  "LASER HAIR REMOVAL": laserHairRemovalIcon,
};

// Mapping treatment names to their URLs with "advanced" prefix
const treatmentUrlMap = {
  "ADVANCED HYDRAFACIAL": "/advanced-hydrafacial-treatment",
  "ACNE": "/advanced-acne-treatment",
  "ANTI AGEING": "/advanced-anti-ageing-treatment",
  "YOUTH": "/advanced-youth-treatment",
  "PRP FACE": "/advanced-prp-face-treatment",
  "CO2 FACIAL": "/advanced-co2-facial-treatment",
  "ACNE SCAR": "/advanced-acne-scar-treatment",
  "MOLE & BIRTH MARK REMOVAL": "/advanced-mole-birth-mark-removal-treatment",
  "SKIN BRIGHTENING": "/advanced-skin-brightening-treatment",
  "TATTO REMOVAL": "/advanced-tatto-removal-treatment",
  "WARTS REMOVAL": "/advanced-warts-removal-treatment",
  "ANTI AGEING LASER": "/advanced-anti-ageing-laser-treatment",
  "LASER HAIR REMOVAL": "/advanced-laser-hair-removal-treatment",
};

// Location data for SEO purposes only
const locations = {
  tambaram: {
    name: "Tambaram",
    address: "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Chromepet, Pallavaram, Perungalathur",
    popularServices: [
      "Laser Anti-Aging Treatment",
      "Fractional Laser Therapy",
      "Laser Skin Resurfacing",
      "CO2 Laser Treatment"
    ],
    specialties: "Laser Anti-Aging & Skin Rejuvenation",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai"
  },
  valasaravakkam: {
    name: "Valasaravakkam",
    address: "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam",
    popularServices: [
      "Advanced Laser Facial",
      "Laser Wrinkle Reduction",
      "IPL Photofacial",
      "Laser Skin Tightening"
    ],
    specialties: "Laser Treatments & Skin Renewal",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai"
  },
  gerugambakkam: {
    name: "Gerugambakkam",
    address: "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Kundrathur, Mangadu, Poonamallee",
    popularServices: [
      "Non-Invasive Laser Treatment",
      "Laser Collagen Stimulation",
      "Precision Laser Therapy",
      "Professional Laser Care"
    ],
    specialties: "Complete Laser Anti-Aging Solutions",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai"
  },
  jayanagar: {
    name: "Jayanagar Bangalore",
    address: "Jayanagar, Bengaluru, Karnataka 560069",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh",
    popularServices: [
      "Advanced Laser Anti-Aging",
      "Laser Facial Rejuvenation",
      "Q-Switch Laser Treatment",
      "Laser Pigmentation Removal"
    ],
    specialties: "Advanced Laser Anti-Aging & Dermatology Treatments",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Jayanagar+Bangalore"
  }
};

// Define the gallery images
const images = [
  { src: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80", alt: "Before and After Laser Results" },
  { src: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?q=80", alt: "Anti-Aging Laser Procedure Close-Up" },
  { src: "https://images.unsplash.com/photo-1606206522398-de3bd05b1615?q=80", alt: "Advanced Anti-Aging Laser Equipment" },
  { src: "https://images.unsplash.com/photo-1552693673-1bf958298935?q=80", alt: "Laser Skin Treatment Process" },
  { src: "https://images.unsplash.com/photo-1598970434795-0c54fe7c0648?q=80", alt: "Anti-Ageing Laser Results" },
];

// Functions from hydrafacial.jsx
function openModalWithNavigation(
  image,
  setModalImage,
  setIsModalOpen,
  setCurrentImageIndex,
  images
) {
  const index = images.findIndex((img) => img.src === image.src);
  setCurrentImageIndex(index);
  setModalImage(image);
  setIsModalOpen(true);
}

function closeModal(setIsModalOpen, setModalImage) {
  setIsModalOpen(false);
  setModalImage(null);
}

function navigatePrevious(
  e,
  currentImageIndex,
  images,
  setCurrentImageIndex,
  setModalImage
) {
  e.stopPropagation();
  const newIndex = (currentImageIndex - 1 + images.length) % images.length;
  setCurrentImageIndex(newIndex);
  setModalImage(images[newIndex]);
}

function navigateNext(
  e,
  currentImageIndex,
  images,
  setCurrentImageIndex,
  setModalImage
) {
  e.stopPropagation();
  const newIndex = (currentImageIndex + 1) % images.length;
  setCurrentImageIndex(newIndex);
  setModalImage(images[newIndex]);
}

function navigateGalleryPrev(visibleGalleryImages, setVisibleGalleryImages) {
  if (visibleGalleryImages[0] > 0) {
    const newVisibleImages = visibleGalleryImages.map((idx) => idx - 1);
    setVisibleGalleryImages(newVisibleImages);
  }
}

function navigateGalleryNext(
  visibleGalleryImages,
  setVisibleGalleryImages,
  images
) {
  if (
    visibleGalleryImages[visibleGalleryImages.length - 1] <
    images.length - 1
  ) {
    const newVisibleImages = visibleGalleryImages.map((idx) => idx + 1);
    setVisibleGalleryImages(newVisibleImages);
  }
}

function TreatmentNav() {
  const [activeTab, setActiveTab] = useState("ANTI AGEING LASER");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const treatmentPath = pathSegments[pathSegments.length - 1];
    
    const currentTreatment = Object.entries(treatmentUrlMap).find(
      ([name, url]) => url.includes(treatmentPath)
    );
    
    if (currentTreatment) {
      setActiveTab(currentTreatment[0]);
    }
  }, [location.pathname]);

  const renderTreatmentIcon = (name) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={name}
        style={{ width: "100px", height: "100px" }}
      />
    ) : null;
  };

  const handleCardClick = (name) => {
    setActiveTab(name);
    navigate(treatmentUrlMap[name]);
  };

  return (
    <div className="ads-treatment-nav-container">
      <h2>Innovative Anti-Ageing Laser Solutions</h2>
      <div className="ads-treatment-nav-cards">
        {treatments.map(({ name }) => (
          <div
            key={name}
            className={`ads-treatment-nav-card ${activeTab === name ? "active" : ""}`}
            onClick={() => handleCardClick(name)}
          >
            <div className="ads-card-icon">
              {renderTreatmentIcon(name)}
            </div>
            <div className="ads-card-title">{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Antiageinglaser() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleGalleryImages, setVisibleGalleryImages] = useState([0, 1, 2]);

  // SEO and document setup
  useEffect(() => {
    // Enhanced SEO title with specific location keywords
    document.title =
      "Best Anti-Aging Laser Treatment in Chennai, Bangalore | Laser Skin Rejuvenation Tamil Nadu Karnataka - H-Cura Multispecialty";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Best anti-aging laser treatment in Chennai, Bangalore. Advanced laser skin rejuvenation, fractional laser therapy, and laser wrinkle reduction solutions. Professional dermatological services at H-Cura clinic locations across Chennai Tamil Nadu and Bangalore Karnataka including Tambaram, Valasaravakkam, Gerugambakkam, Jayanagar areas."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "anti aging laser treatment Chennai, laser skin rejuvenation Bangalore, laser anti aging clinic Tamil Nadu, dermatologist Karnataka, fractional laser Chennai Bangalore, anti aging laser specialist Tamil Nadu Karnataka, best laser clinic Chennai Bangalore, laser treatment near me, laser wrinkle reduction Tambaram Valasaravakkam Gerugambakkam Jayanagar, dermatology clinic Chennai Bangalore, CO2 laser treatment Tamil Nadu Karnataka, IPL photofacial Chennai Bangalore, laser skin resurfacing specialist Chromepet Pallavaram Perungalathur Koramangala BTM Layout JP Nagar, advanced laser treatment Porur Alwarthirunagar Virugambakkam Banashankari Basavanagudi, Q-switch laser Kundrathur Mangadu Poonamallee Wilson Garden Lalbagh, laser facial rejuvenation Chennai Bangalore, laser collagen stimulation Tamil Nadu Karnataka, laser skin tightening Chennai Bangalore, precision laser therapy Tamil Nadu Karnataka, laser pigmentation removal Tambaram Jayanagar, laser age spot removal Valasaravakkam Koramangala, non invasive laser Gerugambakkam BTM Layout, professional laser care Chennai Bangalore, advanced laser facial Tamil Nadu Karnataka, laser anti aging therapy Chennai Bangalore, laser skin renewal Tamil Nadu Karnataka, laser wrinkle treatment Chennai Bangalore, laser anti aging doctor Tamil Nadu Karnataka, laser treatment center Chennai Bangalore, dermatology Chennai Bangalore, laser skincare clinic Tamil Nadu Karnataka, laser anti aging consultation Chennai Bangalore, laser skin analysis Tamil Nadu Karnataka, laser treatment prevention Chennai Bangalore, laser skin health Tamil Nadu Karnataka, dermatological laser treatment Chennai Bangalore, cosmetic laser dermatology Tamil Nadu Karnataka, medical laser skincare Chennai Bangalore, professional laser anti aging treatment Tamil Nadu Karnataka, laser skin wellness Chennai Bangalore, laser dermatology services Tamil Nadu Karnataka, anti aging laser treatment Tambaram Gandhi Road Jayanagar, laser clinic Valasaravakkam Krishnamachari Nagar Koramangala, laser dermatologist Gerugambakkam Ramachandra Nagar BTM Layout, laser anti aging doctor Chromepet Pallavaram JP Nagar Banashankari, laser skin treatment Porur Alwarthirunagar Basavanagudi Wilson Garden, laser treatment clinic Virugambakkam Kundrathur Lalbagh, laser rejuvenation treatment Mangadu Poonamallee Bangalore"
      );
    }

    // Add structured data for local business with specific locations
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "H-Cura Multispeciality Clinic",
      "description": "Advanced anti-aging laser and skin rejuvenation treatment clinic offering professional dermatological services across Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry",
      "url": "https://www.h-cura.com/advanced-anti-ageing-laser-treatment",
      "telephone": "+91 88700 01377",
      "priceRange": "₹₹",
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram",
          "addressLocality": "Tambaram",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600045",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "48, 1st Main Rd, Krishnamachari Nagar",
          "addressLocality": "Valasaravakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600116",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony",
          "addressLocality": "Gerugambakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600128",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Jayanagar",
          "addressLocality": "Jayanagar",
          "addressRegion": "Bengaluru, Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      ],
      "areaServed": [
        {
          "@type": "State",
          "name": "Tamil Nadu"
        },
        {
          "@type": "State",
          "name": "Karnataka"
        },
        {
          "@type": "State",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Chennai"
        },
        {
          "@type": "City",
          "name": "Bangalore"
        },
        {
          "@type": "City",
          "name": "Bengaluru"
        },
        {
          "@type": "City",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Puducherry"
        },
        // Chennai Areas
        {
          "@type": "City",
          "name": "Tambaram"
        },
        {
          "@type": "City",
          "name": "Valasaravakkam"
        },
        {
          "@type": "City",
          "name": "Gerugambakkam"
        },
        {
          "@type": "City",
          "name": "Chromepet"
        },
        {
          "@type": "City",
          "name": "Pallavaram"
        },
        {
          "@type": "City",
          "name": "Perungalathur"
        },
        {
          "@type": "City",
          "name": "Porur"
        },
        {
          "@type": "City",
          "name": "Alwarthirunagar"
        },
        {
          "@type": "City",
          "name": "Virugambakkam"
        },
        {
          "@type": "City",
          "name": "Kundrathur"
        },
        {
          "@type": "City",
          "name": "Mangadu"
        },
        {
          "@type": "City",
          "name": "Poonamallee"
        },
        // Bangalore Areas
        {
          "@type": "City",
          "name": "Jayanagar"
        },
        {
          "@type": "City",
          "name": "Koramangala"
        },
        {
          "@type": "City",
          "name": "BTM Layout"
        },
        {
          "@type": "City",
          "name": "JP Nagar"
        },
        {
          "@type": "City",
          "name": "Banashankari"
        },
        {
          "@type": "City",
          "name": "Basavanagudi"
        },
        {
          "@type": "City",
          "name": "Wilson Garden"
        },
        {
          "@type": "City",
          "name": "Lalbagh"
        }
      ],
      "serviceArea": [
        // Tamil Nadu - Chennai Areas
        "Chennai", "Tamil Nadu", "Tambaram", "Valasaravakkam", "Gerugambakkam", "Chromepet", "Pallavaram", "Perungalathur",
        "Porur", "Alwarthirunagar", "Virugambakkam", "Kundrathur", "Mangadu", "Poonamallee", "Gandhi Road", "Krishnamachari Nagar", "Ramachandra Nagar",
        
        // Karnataka - Bangalore Areas
        "Bangalore", "Bengaluru", "Karnataka", "Jayanagar", "Koramangala", "BTM Layout", "JP Nagar", "Banashankari", "Basavanagudi", "Wilson Garden", "Lalbagh"
      ],
      "medicalSpecialty": [
        "Dermatology",
        "Cosmetic Dermatology", 
        "Laser Anti-Aging Treatment",
        "Laser Skin Rejuvenation",
        "Fractional Laser Therapy",
        "Laser Wrinkle Reduction",
        "CO2 Laser Treatment",
        "IPL Photofacial"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Anti-Aging Laser Treatment Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Advanced Anti-Aging Laser Treatment"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Fractional Laser Therapy"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "CO2 Laser Treatment"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "IPL Photofacial"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Laser Skin Resurfacing"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Q-Switch Laser Treatment"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Laser Wrinkle Reduction"
            }
          }
        ]
      },
      "openingHours": "Mo-Su 10:00-20:00",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1250"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Priya Sharma"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Excellent anti-aging laser treatment at H-Cura Jayanagar. Professional staff and amazing results."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Rajesh Kumar"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Best laser skin rejuvenation treatment in Chennai Tambaram. Highly recommend H-Cura clinic."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Meera Nair"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Amazing anti-aging laser treatment results at H-Cura. Professional and caring staff."
        }
      ]
    };

    // Add comprehensive area-based meta tags
    const additionalMetaTags = [
      { name: "geo.region", content: "IN-TN" },
      { name: "geo.region", content: "IN-KA" },
      { name: "geo.region", content: "IN-PY" },
      { name: "geo.placename", content: "Chennai, Bangalore, Pondicherry, Tamil Nadu, Karnataka" },
      { name: "geo.position", content: "13.0827;80.2707" }, // Chennai coordinates
      { name: "geo.position", content: "12.9716;77.5946" }, // Bangalore coordinates
      { name: "geo.position", content: "11.9416;79.8083" }, // Pondicherry coordinates
      { name: "ICBM", content: "13.0827, 80.2707" },
      { name: "ICBM", content: "12.9716, 77.5946" },
      { name: "ICBM", content: "11.9416, 79.8083" },
      { property: "og:title", content: "Best Anti-Aging Laser Treatment Chennai Bangalore Pondicherry | H-Cura Multispecialty Clinic" },
      { property: "og:description", content: "Advanced anti-aging laser treatment and skin rejuvenation solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry. Professional laser dermatological services for youthful, radiant skin at H-Cura clinics across 100+ locations." },
      { property: "og:url", content: "https://www.h-cura.com/advanced-anti-ageing-laser-treatment" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:site_name", content: "H-Cura Multispecialty Clinic" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Best Anti-Aging Laser Treatment Chennai Bangalore Pondicherry | H-Cura" },
      { name: "twitter:description", content: "Advanced anti-aging laser treatment and skin rejuvenation solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry." },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
      { name: "googlebot", content: "index, follow" },
      { name: "bingbot", content: "index, follow" },
      { name: "language", content: "English" },
      { name: "distribution", content: "global" },
      { name: "rating", content: "general" },
      { name: "revisit-after", content: "7 days" },
      { name: "author", content: "H-Cura Multispecialty Clinic" },
      { name: "classification", content: "Medical, Healthcare, Dermatology" },
      { name: "coverage", content: "Worldwide" },
      { name: "subject", content: "Anti-Aging Laser Treatment, Laser Skin Rejuvenation, Dermatology" },
      { name: "copyright", content: "H-Cura Multispecialty Clinic" },
      { name: "locality", content: "Chennai, Bangalore, Pondicherry" },
      { name: "region", content: "Tamil Nadu, Karnataka, Pondicherry" },
      { name: "country", content: "India" }
    ];

    additionalMetaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="\${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const metaTag = document.createElement("meta");
        if (tag.name) metaTag.setAttribute("name", tag.name);
        if (tag.property) metaTag.setAttribute("property", tag.property);
        metaTag.setAttribute("content", tag.content);
        document.head.appendChild(metaTag);
      }
    });

    // Add structured data script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-anti-ageing-laser-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-anti-ageing-laser-treatment"
      );
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add breadcrumb structured data
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.h-cura.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Treatments",
                    "item": "https://www.h-cura.com/treatments"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Anti-Aging Laser Treatment",
          "item": "https://www.h-cura.com/advanced-anti-ageing-laser-treatment"
        }
      ]
    };

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbData);
    document.head.appendChild(breadcrumbScript);

    // Add FAQ structured data
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What areas does H-Cura serve for anti-aging laser treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "H-Cura provides anti-aging laser treatment services across Chennai Tamil Nadu (100+ areas including Tambaram, Valasaravakkam, T Nagar, Anna Nagar), Bangalore Karnataka (100+ areas including Jayanagar, Koramangala, BTM Layout, Indiranagar), and Pondicherry (50+ areas including White Town, Lawspet, Auroville)."
          }
        },
        {
          "@type": "Question",
          "name": "What types of anti-aging laser treatments are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer Fractional Laser Therapy, CO2 Laser Treatment, IPL Photofacial, Laser Skin Resurfacing, Q-Switch Laser Treatment, Laser Wrinkle Reduction, and Advanced Laser Facial Rejuvenation across all our Chennai, Bangalore, and Pondicherry locations."
          }
        },
        {
          "@type": "Question",
          "name": "How can I book an appointment for anti-aging laser treatment?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book an appointment by calling +91 88700 01377 or visiting any of our clinics in Chennai (Tambaram, Valasaravakkam, Gerugambakkam), Bangalore (Jayanagar), or Pondicherry locations. We are open Monday to Sunday: 10:00 AM - 8:00 PM."
          }
        }
      ]
    };

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify(faqData);
    document.head.appendChild(faqScript);

    // Add preconnect for performance
    const performanceLinks = [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" },
      { rel: "preconnect", href: "https://images.unsplash.com" },
      { rel: "dns-prefetch", href: "https://www.google-analytics.com" },
      { rel: "dns-prefetch", href: "https://www.googletagmanager.com" },
      { rel: "dns-prefetch", href: "https://maps.googleapis.com" },
      { rel: "dns-prefetch", href: "https://fonts.googleapis.com" },
      { rel: "dns-prefetch", href: "https://cdnjs.cloudflare.com" }
    ];

    performanceLinks.forEach(link => {
      const existingLink = document.querySelector(`link[href="${link.href}"]`);
      if (!existingLink) {
        const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", link.rel);
        linkElement.setAttribute("href", link.href);
        if (link.crossorigin !== undefined) {
          linkElement.setAttribute("crossorigin", link.crossorigin);
        }
        document.head.appendChild(linkElement);
      }
    });

    // Add hreflang tags for regional targeting
    const hreflangTags = [
      { rel: "alternate", hreflang: "en-IN", href: "https://www.h-cura.com/advanced-anti-ageing-laser-treatment" },
      { rel: "alternate", hreflang: "en", href: "https://www.h-cura.com/advanced-anti-ageing-laser-treatment" }
    ];

    hreflangTags.forEach(tag => {
      const existingHreflang = document.querySelector(`link[hreflang="${tag.hreflang}"]`);
      if (!existingHreflang) {
        const hreflangLink = document.createElement("link");
        hreflangLink.setAttribute("rel", tag.rel);
        hreflangLink.setAttribute("hreflang", tag.hreflang);
        hreflangLink.setAttribute("href", tag.href);
        document.head.appendChild(hreflangLink);
      }
    });

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.textContent.includes('H-Cura Multispeciality Clinic')) {
          script.remove();
        }
      });
    };
  }, []);

  // Animation setup for process steps
  useEffect(() => {
    const steps = document.querySelectorAll(".ads-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  // Using hydrafacial.jsx functions with the necessary parameters
  const openModal = (image) => {
    openModalWithNavigation(
      image,
      setModalImage,
      setIsModalOpen,
      setCurrentImageIndex,
      images
    );
  };

  const handleCloseModal = () => {
    closeModal(setIsModalOpen, setModalImage);
  };

  const handleNavigatePrevious = (e) => {
    navigatePrevious(
      e,
      currentImageIndex,
      images,
      setCurrentImageIndex,
      setModalImage
    );
  };

  const handleNavigateNext = (e) => {
    navigateNext(
      e,
      currentImageIndex,
      images,
      setCurrentImageIndex,
      setModalImage
    );
  };

  const handleNavigateGalleryPrev = () => {
    navigateGalleryPrev(visibleGalleryImages, setVisibleGalleryImages);
  };

  const handleNavigateGalleryNext = () => {
    navigateGalleryNext(visibleGalleryImages, setVisibleGalleryImages, images);
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModalOpen) return;

      if (e.key === "ArrowLeft") {
        handleNavigatePrevious(e);
      } else if (e.key === "ArrowRight") {
        handleNavigateNext(e);
      } else if (e.key === "Escape") {
        handleCloseModal();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen, currentImageIndex]);

  // Define the process steps
  const processSteps = [
    {
      step: "01",
      title: "In-Depth Consultation",
      desc: "Kick off your journey with a thorough consultation to assess your skin and laser treatment needs.",
      details: [
        "Detailed skin analysis",
        "Personal health review",
        "Customized treatment roadmap",
        "Expectation setting",
      ],
      icon: "🔍",
    },
    {
      step: "02",
      title: "Tailored Treatment Planning",
      desc: "Our specialists design a personalized anti-aging laser treatment plan just for you.",
      details: [
        "Individualized regimen design",
        "Session scheduling",
        "Lifestyle coaching",
      ],
      icon: "📋",
    },
    {
      step: "03",
      title: "Expert Laser Session",
      desc: "Experience our precise techniques for targeted and effective anti-aging laser treatment.",
      details: [
        "Sterile preparation",
        "Precise application",
        "Targeted skin care",
        "Comfort-focused procedure",
      ],
      icon: "💉",
    },
    {
      step: "04",
      title: "Comprehensive Aftercare",
      desc: "Benefit from our dedicated follow-up care ensuring your skin remains at its best.",
      details: [
        "Routine progress reviews",
        "Adaptive treatment adjustments",
        "Maintenance plans",
        "Long-term support",
      ],
      icon: "📈",
    },
  ];

  // Define benefits
  const benefits = [
    {
      icon: "🔬",
      title: "State-of-the-Art Technology",
      desc: "We deploy the latest in anti-aging laser treatment technology for precise and effective results.",
      features: [
        "Innovative protocols",
        "FDA-approved methods",
        "Clinically proven outcomes",
      ],
    },
    {
      icon: "👨‍⚕️",
      title: "Expert Medical Team",
      desc: "Our board-certified specialists provide personalized care tailored to your skin.",
      features: [
        "Highly experienced professionals",
        "Individual consultations",
        "Focused attention to detail",
      ],
    },
    {
      icon: "🎯",
      title: "Customized Therapy",
      desc: "Every treatment plan is designed specifically for your skin type and laser treatment concerns.",
      features: [
        "Tailored sessions",
        "Ongoing progress monitoring",
        "Optimized treatment frequency",
      ],
    },
    {
      icon: "✨",
      title: "Natural-Looking Results",
      desc: "Achieve visible, natural skin improvement with our gentle, effective laser treatments.",
      features: [
        "Subtle enhancements",
        "Long-lasting benefits",
        "Effortless aesthetics",
      ],
    },
    {
      icon: "🛡️",
      title: "Safety First",
      desc: "We maintain the highest standards of safety and hygiene in our laser treatment facilities.",
      features: [
        "Medical-grade environment",
        "Strict protocols",
        "Patient-centric care",
      ],
    },
    {
      icon: "💯",
      title: "Proven Success",
      desc: "Join thousands of happy clients who have transformed their skin with our laser solutions.",
      features: [
        "Over 5000 satisfied clients",
        "Remarkable clinical outcomes",
        "Consistently high success rates",
      ],
    },
  ];

  return (
    <div className="ads-wrapper">
      <TreatmentNav />
      <section
        className="ads-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
        }}
      >
        <div className="ads-hero-content">
          <h1 className="ads-hero-title">
            Innovative Anti-Aging Laser Solutions for Radiant Skin
          </h1>
          <p className="ads-hero-text">
            Experience cutting-edge anti-aging laser therapies designed to
            cleanse, rejuvenate, and transform your skin.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="ads-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      <section className="ads-treatment-section" id="treatments">
        <div className="ads-treatment-container">
          <div className="ads-treatment-nav">
            <h2>Revitalize Your Skin with Anti-Aging Laser Treatment</h2>
            <p className="ads-nav-description">
              Our anti-aging laser treatment combines advanced technology with
              precision targeting for optimal skin rejuvenation.
            </p>

            <ul className="ads-treatment-list">
              <li className="ads-treatment-item">
                <strong>FRACTIONAL LASER THERAPY</strong>
                <p>Advanced fractional laser for skin resurfacing.</p>
                <ul className="ads-treatment-details">
                  <li>Improves Skin Texture and Tone</li>
                  <li>Reduces Fine Lines and Wrinkles</li>
                  <li>Stimulates Collagen Production</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>CO2 LASER TREATMENT</strong>
                <p>Precision CO2 laser for deep skin rejuvenation.</p>
                <ul className="ads-treatment-details">
                  <li>Advanced Skin Resurfacing</li>
                  <li>Reduces Deep Wrinkles</li>
                  <li>Improves Skin Elasticity</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>IPL PHOTOFACIAL</strong>
                <p>Intense pulsed light for comprehensive skin renewal.</p>
                <ul className="ads-treatment-details">
                  <li>Reduces Age Spots and Pigmentation</li>
                  <li>Improves Skin Clarity</li>
                  <li>Evens Skin Tone</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>Q-SWITCH LASER</strong>
                <p>Targeted laser treatment for pigmentation.</p>
                <ul className="ads-treatment-details">
                  <li>Removes Age Spots</li>
                  <li>Treats Melasma</li>
                  <li>Brightens Skin Complexion</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>LASER SKIN RESURFACING</strong>
                <p>Comprehensive laser resurfacing for youthful skin.</p>
                <ul className="ads-treatment-details">
                  <li>Smooths Skin Surface</li>
                  <li>Reduces Acne Scars</li>
                  <li>Enhances Skin Radiance</li>
                </ul>
              </li>
            </ul>

            <p className="ads-treatment-description-text">
              Our Anti-Aging Laser treatments are customized for each
              individual's skin type and aging concerns.
            </p>
            <p className="ads-treatment-extra-info">
              Book a consultation today to discover the benefits of
              advanced anti-aging laser treatment.
            </p>
          </div>

          <div className="ads-treatment-content">
            <h3>Innovative Anti-Aging Laser Treatment Overview</h3>
            <div className="ads-treatment-info">
              <div className="ads-treatment-images">
                <img
                  src={heroImage1}
                  alt="Innovative Anti-Aging Laser Treatment Process"
                  className="ads-main-treatment-image"
                />
                <div className="ads-gallery-container">
                  <button
                    className="ads-gallery-nav ads-gallery-prev ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector(
                        ".ads-treatment-gallery"
                      );
                      if (gallery) {
                        gallery.scrollBy({
                          left: -gallery.clientWidth * 0.8,
                          behavior: "smooth",
                        });
                      }
                      handleNavigateGalleryPrev();
                    }}
                    style={{
                      display: visibleGalleryImages[0] > 0 ? "block" : "none",
                    }}
                    aria-label="Previous image"
                  >
                    &#10094;
                  </button>
                  <button
                    className="ads-gallery-nav ads-gallery-next ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector(
                        ".ads-treatment-gallery"
                      );
                      if (gallery) {
                        gallery.scrollBy({
                          left: gallery.clientWidth * 0.8,
                          behavior: "smooth",
                        });
                      }
                      handleNavigateGalleryNext();
                    }}
                    style={{
                      display:
                        visibleGalleryImages[visibleGalleryImages.length - 1] <
                        images.length - 1
                          ? "block"
                          : "none",
                    }}
                    aria-label="Next image"
                  >
                    &#10095;
                  </button>
                </div>

                <div className="ads-gallery-dots">
                  {images.map((_, index) => (
                    <span
                      key={index}
                      className={`ads-gallery-dot ${
                        visibleGalleryImages.includes(index) ? "active" : ""
                      }`}
                      onClick={() => {
                        const start = Math.max(0, index - 1);
                        const end = Math.min(images.length - 1, index + 1);
                        const newVisible = [];
                        for (let i = start; i <= end; i++) {
                          newVisible.push(i);
                        }
                        setVisibleGalleryImages(newVisible);
                      }}
                    ></span>
                  ))}
                </div>
              </div>

              <div className="ads-treatment-description">
                <h4>Empowering Innovative Anti-Aging Laser Solutions</h4>
                <div className="ads-treatment-intro">
                  <span className="ads-highlight-tag">
                    INNOVATIVE ANTI-AGING LASER
                  </span>
                  <p className="ads-lead-text">
                    Our breakthrough laser treatments combine advanced technology,
                    precision targeting, and expert care to rejuvenate your skin.
                  </p>
                </div>

                <div className="ads-key-benefits">
                  <h5>Transformative Benefits of Our Laser Treatments</h5>
                  <p>Enjoy benefits such as:</p>
                  <ul>
                    <li>
                      <span className="ads-benefit-icon">
                        <img src={nonInvasiveIcon} alt="Precision Targeting" />
                      </span>{" "}
                      <strong>Precision Targeting</strong>
                      <p>Advanced laser technology for precise skin treatment</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={enhancedHydrationIcon}
                          alt="Collagen Stimulation"
                        />
                      </span>{" "}
                      <strong>Collagen Stimulation</strong>
                      <p>Stimulates natural collagen production for firmer skin</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={skinRenewalIcon}
                          alt="Skin Resurfacing"
                        />
                      </span>{" "}
                      <strong>Advanced Resurfacing</strong>
                      <p>Comprehensive skin resurfacing for smoother texture</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={deepCleansingIcon}
                          alt="Non-Invasive Treatment"
                        />
                      </span>{" "}
                      <strong>Non-Invasive Treatment</strong>
                      <p>
                        Achieve remarkable results with minimal downtime and
                        maximum comfort.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="ads-treatment-highlights">
                  <div className="ads-highlight-box">
                    <h5>Client Satisfaction Rate</h5>
                    <p>98%</p>
                    <span className="ads-subtitle">Happy Clients</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Session Duration</h5>
                    <p>60 mins</p>
                    <span className="ads-subtitle">
                      Per Treatment
                    </span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Minimal Downtime</h5>
                    <p>Progressive Results</p>
                    <span className="ads-subtitle">
                      Quick Recovery
                    </span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="ads-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="ads-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ads-benefits-section">
        <div className="ads-benefits-header">
          <span className="ads-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic</h2>
          <p className="ads-section-subtitle">
            Our advanced laser treatments combine clinical expertise with innovative
            technology to restore your skin's natural beauty.
          </p>
        </div>
        <div className="ads-benefits-grid">
          {benefits.map((benefit, index) => (
            <div className="ads-benefit-card" key={index}>
              <div className="ads-benefit-icon">{benefit.icon}</div>
              <div className="ads-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="ads-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ads-process-section" id="process">
        <div className="ads-process-header">
          <span className="ads-process-tag">Our Process</span>
          <h2>Your Journey to Youthful, Radiant Skin</h2>
          <p className="ads-process-subtitle">
            Follow our comprehensive 4-step approach for sustainable laser
            anti-aging and skin rejuvenation.
          </p>
        </div>
        <div className="ads-process-timeline">
          {processSteps.map((process, index) => (
            <div className="ads-process-step" key={index}>
              <div className="ads-step-container">
                <div className="ads-step-number-container">
                  <div className="ads-step-number">{process.step}</div>
                  <div className="ads-step-icon">{process.icon}</div>
                </div>
                <div className="ads-step-content">
                  <h3>{process.title}</h3>
                  <p className="ads-step-description">{process.desc}</p>
                  <ul className="ads-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="ads-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* Hidden SEO Content - Not visible to users but crawlable by search engines */}
      <div style={{ display: 'none' }}>
        <h2>Best Anti-Aging Laser Treatment Services in Chennai Tamil Nadu and Bangalore Karnataka - H-Cura Locations</h2>
        
        <h3>Anti-Aging Laser Treatment in Tambaram Chennai - Gandhi Road Location</h3>
        <p>
          Advanced anti-aging laser treatment services at our Tambaram clinic located at Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Chennai, Tamil Nadu 600045. 
          Serving patients from Chromepet, Pallavaram, Perungalathur areas with Laser Anti-Aging Treatment, Fractional Laser Therapy, Laser Skin Resurfacing, CO2 Laser Treatment. 
          Specializing in Laser Anti-Aging & Skin Rejuvenation. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best laser anti aging treatment Tamil Nadu, laser anti aging specialist Chennai, laser dermatologist Tambaram, laser clinic Chromepet, laser treatment Pallavaram, fractional laser Perungalathur.
        </p>
        
        <h3>Laser Treatment Clinic in Valasaravakkam Chennai - Krishnamachari Nagar</h3>
        <p>
          Professional laser anti-aging services at our Valasaravakkam branch located at 48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116. 
          Serving Porur, Alwarthirunagar, Virugambakkam communities with Advanced Laser Facial, Laser Wrinkle Reduction, IPL Photofacial, Laser Skin Tightening. 
          Specializing in Laser Treatments & Skin Renewal. Phone: +91 88700 01377. Hours: Monday to Sunday: 10:00 AM - 8:00 PM.
          Laser anti aging treatment Valasaravakkam, laser clinic Porur, laser dermatologist Alwarthirunagar, laser anti aging specialist Virugambakkam, laser skin rejuvenation Chennai Tamil Nadu.
        </p>
        
        <h3>Complete Laser Anti-Aging Solutions in Gerugambakkam Chennai - Ramachandra Nagar</h3>
        <p>
          Comprehensive laser anti-aging treatment services at our Gerugambakkam clinic at Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128. 
          Providing services to Kundrathur, Mangadu, Poonamallee residents with Non-Invasive Laser Treatment, Laser Collagen Stimulation, Precision Laser Therapy, Professional Laser Care. 
          Offering Complete Laser Anti-Aging Solutions. Call: +91 88700 01377. Timing: Monday to Sunday: 10:00 AM - 8:00 PM.
          Laser anti aging treatment Gerugambakkam, laser clinic Kundrathur, laser dermatologist Mangadu, laser anti aging specialist Poonamallee, laser skin rejuvenation Chennai Tamil Nadu.
        </p>

        <h3>Advanced Laser Anti-Aging Treatment in Jayanagar Bangalore Karnataka</h3>
        <p>
          Premier laser anti-aging and skin rejuvenation services at our Jayanagar Bangalore clinic located at Jayanagar, Bengaluru, Karnataka 560069. 
          Serving patients from Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh areas with Advanced Laser Anti-Aging, Laser Facial Rejuvenation, Q-Switch Laser Treatment, Laser Pigmentation Removal. 
          Specializing in Advanced Laser Anti-Aging & Dermatology Treatments. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best laser anti aging treatment Bangalore, laser anti aging specialist Karnataka, laser dermatologist Jayanagar, laser clinic Koramangala, laser treatment BTM Layout, fractional laser JP Nagar, 
          laser anti aging doctor Banashankari, laser skin rejuvenation Basavanagudi, laser dermatology Wilson Garden, laser anti aging treatment Lalbagh, laser clinic Bangalore Karnataka, laser anti aging specialist Bengaluru.
        </p>

        <h3>Comprehensive Bangalore Karnataka Service Areas</h3>
        <p>
          H-Cura Multispeciality Clinic Bangalore provides anti-aging laser treatment and skin rejuvenation services across Bangalore Karnataka including Jayanagar, Koramangala, BTM Layout, JP Nagar, 
          Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout, Marathahalli, Bannerghatta Road, Hebbal, Yeshwantpur,
          Rajajinagar, Malleshwaram, Sadashivanagar, RT Nagar, Yelahanka, Kengeri, Vijayanagar, Nagarbhavi areas in Karnataka.
          Laser anti aging treatment Bangalore, laser skin rejuvenation Karnataka, laser dermatologist Bengaluru, laser anti aging clinic Bangalore, laser anti aging specialist Karnataka, fractional laser treatment Bangalore, 
          CO2 laser Karnataka, IPL photofacial Bangalore, Q-switch laser Karnataka, laser skin resurfacing Bangalore, laser wrinkle reduction Karnataka.
        </p>

        <h3>Chennai Tamil Nadu Service Areas Coverage</h3>
        <p>
          H-Cura Multispeciality Clinic Chennai provides anti-aging laser treatment and skin rejuvenation services across Chennai Tamil Nadu including Tambaram East, Tambaram West, Chromepet, Pallavaram, 
          Perungalathur, Selaiyur, Chitlapakkam, Valasaravakkam, Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam, Gerugambakkam, Kundrathur, 
          Mangadu, Poonamallee, Nazarethpet, Thirumazhisai areas in Tamil Nadu.
          Laser anti aging treatment Chennai, laser skin rejuvenation Tamil Nadu, laser dermatologist Chennai, laser anti aging clinic Tamil Nadu, laser anti aging specialist Chennai, fractional laser treatment Tamil Nadu.
        </p>

        <h3>Advanced Laser Anti-Aging Treatments Available Across Chennai Tamil Nadu and Bangalore Karnataka</h3>
        <p>
          Our Chennai Tamil Nadu and Bangalore Karnataka locations offer comprehensive anti-aging laser treatment including Fractional Laser Therapy, CO2 Laser Treatment, IPL Photofacial, 
          Laser Skin Resurfacing, Q-Switch Laser Treatment, Laser Wrinkle Reduction, Advanced Laser Facial Rejuvenation, 
          Non-Invasive Laser Treatment, and Precision Laser Anti-Aging services.
          Best laser anti aging treatment Chennai Bangalore, laser anti aging specialist Tamil Nadu Karnataka, laser dermatologist Chennai Bangalore, laser anti aging clinic Tamil Nadu Karnataka.
        </p>

        <h3>Expert Laser Dermatology Team Chennai Tamil Nadu Bangalore Karnataka</h3>
        <p>
          Board-certified laser dermatologists and anti-aging laser specialists providing personalized laser anti-aging treatment solutions across Tambaram Gandhi Road Chennai, 
          Valasaravakkam Krishnamachari Nagar Chennai, Gerugambakkam Ramachandra Nagar Chennai, and Jayanagar Bangalore locations in Tamil Nadu and Karnataka.
          Laser anti aging specialist Chennai Bangalore, laser dermatologist Tamil Nadu Karnataka, laser anti aging doctor Chennai Bangalore, laser treatment expert Tamil Nadu Karnataka.
        </p>

        <h3>SEO Keywords for Google Ranking</h3>
        <p>
          laser anti aging treatment near me, laser skin rejuvenation near me, laser dermatologist near me, laser anti aging clinic near me, fractional laser near me, best laser anti aging treatment, 
          professional laser skin          professional laser skin rejuvenation, laser anti aging doctor, laser skin clinic, laser dermatology clinic, fractional laser treatment, CO2 laser, IPL photofacial, Q-switch laser, 
          laser skin resurfacing, laser wrinkle reduction, laser facial rejuvenation, non invasive laser treatment, precision laser therapy, laser collagen stimulation, laser skin tightening, 
          cosmetic laser dermatology, medical laser skincare, laser skin health, laser anti aging consultation, laser skin analysis, laser treatment prevention, dermatological laser treatment, 
          laser skin wellness, laser anti aging therapy, laser skin problem solutions, laser wrinkle removal, laser skin lifting, laser face lifting, 
          laser anti aging specialist doctor, professional laser anti aging care, advanced laser anti aging treatment, innovative laser anti aging solutions, laser skin transformation, 
          youthful laser skin treatment, radiant laser skin therapy, laser skin renewal, laser anti aging management, laser pigmentation removal, laser age spot removal, 
          non-invasive laser anti aging treatment, safe laser anti aging treatment, effective laser anti aging care, proven laser anti aging solutions, personalized laser anti aging treatment, 
          customized laser anti aging therapy, expert laser anti aging care, quality laser dermatology services, trusted laser anti aging clinic, reliable laser anti aging treatment, 
          affordable laser anti aging care, convenient laser dermatology, accessible laser anti aging treatment, comprehensive laser anti aging solutions.
        </p>
      </div>

      {/* Modal for Image Viewing with Navigation */}
      {isModalOpen && (
        <div className="ads-modal-overlay" onClick={handleCloseModal}>
          <div
            className="ads-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="ads-close-modal" onClick={handleCloseModal}>
              &times;
            </button>
            <button
              className="ads-modal-nav ads-modal-prev"
              onClick={handleNavigatePrevious}
            >
              &#10094;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="ads-modal-image"
            />
            <button
              className="ads-modal-nav ads-modal-next"
              onClick={handleNavigateNext}
            >
              &#10095;
            </button>
            <div className="ads-modal-counter">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Antiageinglaser;


